import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  CtlGenKisiComponent,
  CtlGenKisiGelirComponent,
  CtlGenKullaniciComponent,
  CtlTebDonemComponent,
  CtlTebFinansmanComponent,
  CtlTebFonksiyonComponent,
  CtlTebGelirComponent,
  CtlTebGiderComponent,
  CtlTebKurumSinifComponent,
  CtlTemDefterTurComponent,
  CtlTemHarcamaComponent,
  CtlTemHesapComponent,
  CtlTemImzaYetkiComponent,
  CtlTemTaahhutComponent,
  CtlTemDefterComponent,
  CtlTemDonemComponent,
  CtlIkaPersonelComponent,
  CtlGenKontrolComponent,
  CtlTebEkonomikComponent,
  CtlTmsAmbarBlokComponent,
  CtlTmsAmbarBolumComponent,
  CtlTmsAmbarRafComponent,
  CtlBirimTurTreeComponent,
  CtlSasAboneKisiComponent

} from '@dabnet-kamu/libs/ui';
import {
  DxButtonModule,
  DxSortableModule,
  DxTabPanelModule,
  DxListModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxRadioGroupModule
} from 'devextreme-angular';

import { Router } from '@angular/router';
import {
  CtlTmsCikisYerComponent
} from "../../../../../ui/src/lib/shared/components/controls/ctl-tms-cikis-yer/ctl-tms-cikis-yer.component";
import {
  CtlGenMahalleCaddeSokakComponent
} from "@dabnet-kamu/libs/ui";
import {
  CtlTmsTasinirGirisBakiyeComponent
} from "../../../../../ui/src/lib/shared/components/controls/ctl-tms-tasinir-giris-bakiye/ctl-tms-tasinir-giris-bakiye.component";
import {
  CtlTmsAmbarComponent
} from "../../../../../ui/src/lib/shared/components/controls/ctl-tms-ambar/ctl-tms-ambar.component";
import {
  CtlTmsDemirbasComponent
} from "../../../../../ui/src/lib/shared/components/controls/ctl-tms-demirbas/ctl-tms-demirbas.component";
import {
    CtlGysTahsilAnaComponent
} from "../../../../../ui/src/lib/shared/components/controls/ctl-gys-tahsil-ana/ctl-gys-tahsil-ana.component";
import { ControlConditionModel } from 'libs/ui/src/lib/shared/models/gen-control.model';

@Component({
  selector: 'dk-kontroller',
  standalone: true,
  templateUrl: './kontroller.component.html',
  styleUrls: ['./kontroller.component.scss'],
    imports: [
        CommonModule,
        DxButtonModule,
        DxSortableModule,
        DxTabPanelModule,
        DxListModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxRadioGroupModule,
        CtlGenKisiComponent,
        CtlGenKisiGelirComponent,
        CtlGenKullaniciComponent,
        CtlTebDonemComponent,
        CtlTebFinansmanComponent,
        CtlTebFonksiyonComponent,
        CtlTebGelirComponent,
        CtlTebGiderComponent,
        CtlTebEkonomikComponent,
        CtlTebKurumSinifComponent,
        CtlTemDefterTurComponent,
        CtlTemHarcamaComponent,
        CtlTemHesapComponent,
        CtlTemImzaYetkiComponent,
        CtlTemTaahhutComponent,
        CtlTemDefterComponent,
        CtlTemDonemComponent,
        CtlIkaPersonelComponent,
        CtlGenKontrolComponent,
        CtlTmsAmbarBlokComponent,
        CtlTmsAmbarBolumComponent,
        CtlTmsAmbarRafComponent,
        CtlTmsCikisYerComponent,
        CtlGenMahalleCaddeSokakComponent,
        CtlTmsTasinirGirisBakiyeComponent,
        CtlTmsAmbarComponent,
        CtlTmsDemirbasComponent,
        CtlBirimTurTreeComponent,
        CtlGysTahsilAnaComponent,
        CtlSasAboneKisiComponent
    ],
})
export class KontrollerComponent {
  public controlDate = new Date();
  public tebSeciliDonem: number | null;
  public temSeciliDonem: number | null;
  public selectedControlPeriod: number | null;
  public controlName = "";
  public controlName2 = "";
  public piHesapTuru:number;
  public blokCode:number;
  public harcamaKodu:number|null = null;
  public priorities:any;
  public controlCondition: ControlConditionModel[] = [{
    conditionColName: "BirimTuru",
    conditionColSymbol: "=",
    conditionColText: "I"
  },{
    conditionColName: "BirimAdres",
    conditionColSymbol: "=",
    conditionColText: "Malkoç Mah. Atatürk Cad. No:2 10900 Gönen/ Balıkesir"
  },{
    conditionColName: "TelNo",
    conditionColSymbol: "=",
    conditionColText: "7621845"
  }]
  constructor(private router: Router) {
    this.priorities = [
      1,
      2,
      3,
      4,
    ];}

    piHesapTuruSelect(e:any){
      this.piHesapTuru = e;
    }
    piHarcamaKoduSelect(e:any){
      this.harcamaKodu = e;
    }
  mainRoute() {
    this.router.navigate(['/main/dabnet']);
  }
  getTebPeriod(e:any){
    if(e === null) this.tebSeciliDonem = null;
    else this.tebSeciliDonem = e.Yil;
  }
  getTemPeriod(e:any){
    if(e === null) this.temSeciliDonem = null;
    else this.temSeciliDonem = e.Donem;
  }
  onValueChangeTable(e:any){
    this.controlName = e.value;
  }
  onValueChangeTable2(e:any){
    this.controlName2 = e.value;
  }
  onValueChangeTablePeriod2(e:any){
    if(e === null) this.selectedControlPeriod = null;
    else this.selectedControlPeriod = e.Yil;
  }

  getTmsTasinir(e:any){
  }

  getTmsDemirbasYer(e:any){
  }

  getTmsAmbarBlok(e:any){
    this.blokCode = e.Kod;
  }

  mutlipleSelectResult:any;
  setDataresult($event: any) {
    //this.mutlipleSelectResult = $event[0]
  }
}
